<script>
import CustomersApi from "@/services/customers-api";
import ReportingApi from "@/services/reporting-api";

export default {
    props: {
      firstDay:{
          type:String,
          default:null
      },
      lastDay:{
          type:String,
          default:null
      }
    },
    data(){
        return{
            accessHistory: [],
            fields: [
                { key:"customer", label: ""},
                { key:"user", label: ""},
                { key:"ip", label: "", sortable: false},
                { key:"userAgent", label: ""},
                { key:"date", label: ""},],
            pagemodel: {currentPage : 1, perPage :10, totalRows: 0},
            customersList:[],
            selectedCustomer:null,
            start:this.firstDay,
            end:this.lastDay,
            isGetAccesshHistoryStarting:false,

        }
    },
    methods:{
        getAccessHistory(){
            this.isGetAccesshHistoryStarting=true
            ReportingApi.getAccessHistory(this.pagemodel.currentPage, this.pagemodel.perPage,this.start,this.end,this.selectedCustomer==null ? null : this.selectedCustomer.id).then(
                (result) => {
                    if(result){
                        this.accessHistory=result.list;
                        this.pagemodel.totalRows = result.total;
                        this.pagemodel.currentPage = result.page;
                        this.pagemodel.perPage = result.pageSize;
                        this.pagemodel.pageSize = result.pageSize;
                    }
                }
            ).finally(()=>{
                this.isGetAccesshHistoryStarting=false
            })
        },
        getCustomers(){
        CustomersApi.getCustomers(null,null).then(
            response => {
            this.customersList=response;
            }
        )
        },
    },
    mounted(){
      this.getCustomers()
      this.getAccessHistory()
    },
    watch: {
        end: function(){
          if((this.end  && this.start) || (!this.end  && !this.start) ){
            this.getAccessHistory()
          }
          
        },
        start: function(){
          if((this.end && this.start) || (!this.end  && !this.start)  ){
            this.getAccessHistory()
          }
        },

        selectedCustomer: function(){
            this.getAccessHistory()
        }
    }
}
</script>
<template>
    <div class="clearfix m-4">
        <h4 class="card-title mb-4 font-size-18 font-weight-bold text-dark">{{$t("reporting.supplier.access.cardTitle")}} </h4>
        <div  class="row mt-4">
            <div  class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 pr-lg-2 ">
            <b-form-group :label="$t('lists.customers.filter')" label-for="">
                <v-select class="style-vselect-big" style="font-size:1.2em;" :options="customersList" :placeholder="$t('lists.customers.label')" label="fullCompanyName" v-model="selectedCustomer">
                <span slot="no-options">{{$t('lists.emptyLists.label')}}</span>
                </v-select>
            </b-form-group>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 pr-lg-2 ">
            <b-form-group :label="$t('datPicker.startDate.label-no-date-selected')"  label-for="">
                <b-form-datepicker
                v-model="start"
                :locale="$t('datPicker.locale')"
                :label-no-date-selected="$t('datPicker.startDate.label-no-date-selected')"
                dark
                reset-button
                close-button
                :label-reset-button="$t('datPicker.label-reset-button')"
                :label-close-button="$t('datPicker.label-close-button')"
                dropright
                hide-header
                ></b-form-datepicker>
            </b-form-group>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-12 col-sm-12 col-xs-12 ">
            <b-form-group :label="$t('datPicker.endDate.label-no-date-selected')"  label-for="">
                <b-form-datepicker
                v-model="end"
                :locale="$t('datPicker.locale')"
                :label-no-date-selected="$t('datPicker.endDate.label-no-date-selected')"
                dark
                reset-button
                close-button
                :label-reset-button="$t('datPicker.label-reset-button')"
                :label-close-button="$t('datPicker.label-close-button')"
                dropright                         
                hide-header
                ></b-form-datepicker>
            </b-form-group>
            </div>
        </div>
        <div class="table-responsive mb-0" style="max-height:31em;min-height:31em">
            <b-table
            :busy="false"
            :striped="true"
            :small="true"
            :hover="true"
            :items="accessHistory"
            :fields="fields"
            :perPage="pagemodel.perPage"
            thead-style="display: none"
            >
            <template v-slot:table-busy>
            <div class="text-center my-2">
                <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
            </div>
            </template>
            <template v-slot:head(date)>
                {{ $t("reporting.supplier.access.fields.date") }} 
            </template>
            <template v-slot:head(customer)>
                {{ $t("reporting.supplier.access.fields.customer") }} 
            </template>
            <template v-slot:head(user)>
                {{ $t("reporting.supplier.access.fields.user") }} 
            </template>
            <template v-slot:head(ip)>
                {{ $t("reporting.supplier.access.fields.ip") }} 
            </template>
            <template v-slot:head(userAgent)>
                {{ $t("reporting.supplier.access.fields.userAgent") }} 
            </template>
            <template v-slot:cell(ip)="{value}">
                <code>{{value==null ? "_" : value}}</code>
            </template>

            <template v-slot:cell(userAgent)="{value}">
                <code>{{value==null ? "_" : value}}</code>
            </template>

            </b-table>
            <span v-if="!isGetAccesshHistoryStarting && !accessHistory.length" class="d-flex justify-content-center m-4 text-danger" >{{$t("reporting.supplier.emptyTable") }} </span>
        </div>
        <!-- Pagination -->
        <div class="row pt-3 pl-2 mb-sm-4">
            <div class="col-sm-8">
                <div class="dataTables_paginate paging_simple_numbers float-left d-none d-md-flex">
                    <b-form-select @input="getAccessHistory()"  v-model="pagemodel.perPage" size="sm" style="width: 5em" :options="[10,15,50,100]"></b-form-select>
                    <div class="d-none d-lg-inline pt-1"><span class="text-muted mb-0 ml-1">{{ $t("pagination.from") }} </span><span class="font-weight-bold"> {{pagemodel.totalRows}} {{ $t("pagination.lines") }}</span></div>
                </div>
            </div>
            <div class="col-sm-4">
                <div class="dataTables_paginate paging_simple_numbers float-right">
                    <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="pagemodel.currentPage" :per-page="pagemodel.pageSize" :total-rows="pagemodel.totalRows" @input="getAccessHistory()" :disabled="isGetAccesshHistoryStarting" ></b-pagination>
                    </ul>
                </div>
            </div>
        </div> 
        <!-- Fin Pagination  --> 
    </div>
</template>